/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = 'https://operators.staging.zonarsystems.net/api/v1beta2';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
